import { Component, OnInit } from '@angular/core';
import { UtilityProvider } from 'app/providers/utility/utility';
import { DataManagement } from 'app/services/dataManagement';
import * as Chart from 'chart.js';


@Component({
  selector: 'app-analisis',
  templateUrl: './analisis.component.html',
  styleUrls: ['./analisis.component.scss']
})
export class AnalisisComponent implements OnInit {

  
  loading: boolean = false;
  muestraPrompt: boolean = false;
  prompt: string = '';
  muestraTipificaciones: boolean = false;
  muestraVoces: boolean = false;
  vozActual: string = 'UOIqAnmS11Reiei1Ytkc'; // Carolina
  textoIa: string = '';
  textoBoton: string = 'Generar Voz';

  subidaModelo() {
    this.utils.openDialog("Función no disponible.", "Contacte con ventas", false, false);
  }

  async makeVoice() {
    this.loading = true;
    this.textoBoton = 'Generando voz...'
    let text = (document.getElementById("textoIa") as HTMLTextAreaElement);
    this.textoIa = text.value;
    let voz = await this.dm.makeVoice(this.vozActual, this.textoIa);
    console.log(voz);
    if (voz.status === 'ok') {
      let audio = document.getElementById('miaudio') as HTMLAudioElement;
      audio.src = 'data:audio/mpeg;base64,' + voz.message;
      this.loading = false;
      audio.play();
      this.textoBoton = 'Generar Voz';
    } else {
        this.loading = false;
        this.textoBoton = 'Generar Voz';
        this.utils.openDialog("No ha podido reproducir voz.", "Inténtelo de nuevo.", false, false);
    }
  }
  
  enviarCamp() {
    this.utils.openDialog("Campaña creada con éxito.", "Cambios realizados correctamente", false, false);
  }

  makeTipificaciones() {
    this.utils.openDialog("Nuevas Tipificaciones establecidas.", "Cambios realizados correctamente", false, false);
  }

  mostrarVoces() {
    this.vozActual = 'UOIqAnmS11Reiei1Ytkc';
    this.muestraVoces = true;
    this.textoIa = '';
    setTimeout(() => {
      let area = (document.getElementById("textoIa") as HTMLTextAreaElement);
      area.value = "";
      this.loading = false;
    }, 500)
    
  }

  mostrarPrompt() {
    this.loading = true;
    this.muestraPrompt = true;
    this.prompt = '';
    setTimeout(() => {
      let area = (document.getElementById("prompt") as HTMLTextAreaElement);
      area.value = "";
      this.loading = false;
    }, 500)
    
  }

  mostrarTipificaciones() {
    this.loading = true;
    this.muestraTipificaciones = true;
    this.prompt = '';
    setTimeout(() => {
      let area = (document.getElementById("tipificaciones") as HTMLTextAreaElement);
      area.value = "";
      this.loading = false;
    }, 500)
    
  }


    generateDiagram() {
        const presupuesto = parseInt((document.getElementById('presupuesto') as HTMLInputElement).value);
        const autoridad = parseInt((document.getElementById('autoridad') as HTMLInputElement).value);
        const necesidad = parseInt((document.getElementById('necesidad') as HTMLInputElement).value);
        const tiempo = parseInt((document.getElementById('tiempo') as HTMLInputElement).value);
        const quiereReunion = parseInt((document.getElementById('quiereReunion') as HTMLInputElement).value);
        const agendadaReunion = parseInt((document.getElementById('agendadaReunion') as HTMLInputElement).value);

        const ctx = (document.getElementById('myChart') as HTMLCanvasElement).getContext('2d');

        const data = {
            labels: ['Presupuesto', 'Autoridad', 'Necesidad', 'Tiempo', 'Quiere reunión', 'Agendada reunión'],
            datasets: [{
                label: 'Acciones realizadas (%)',
                data: [presupuesto, autoridad, necesidad, tiempo, quiereReunion, agendadaReunion],
                backgroundColor: 'rgba(75, 192, 192, 0.6)',
                borderColor: 'rgba(75, 192, 192, 1)',
                borderWidth: 1,
                pointRadius: 6,
                fill: false,
                tension: 0.1,
                showLine: true
            }]
        };

        const options = {
            scales: {
                x: {
                    type: 'category',
                    labels: ['Presupuesto', 'Autoridad', 'Necesidad', 'Tiempo', 'Quiere reunión', 'Agendada reunión']
                },
                y: {
                    beginAtZero: true,
                    max: 100,
                    ticks: {
                        stepSize: 10
                    }
                }
            },
            plugins: {
                tooltip: {
                    callbacks: {
                        label: function(context) {
                            let label = context.dataset.label || '';
                            if (label) {
                                label += ': ';
                            }
                            if (context.raw !== null) {
                                label += context.raw + '%';
                            }
                            return label;
                        }
                    }
                }
            }
        };

        new Chart(ctx, {
            type: 'line',
            data: data,
            
    });

        document.getElementById('summary').style.display = 'inline-block';
    }


    generateSummary() {
        const presupuesto = parseInt((document.getElementById('presupuesto') as HTMLInputElement).value);
        const autoridad = parseInt((document.getElementById('autoridad') as HTMLInputElement).value);
        const necesidad = parseInt((document.getElementById('necesidad') as HTMLInputElement).value);
        const tiempo = parseInt((document.getElementById('tiempo') as HTMLInputElement).value);
        const quiereReunion = parseInt((document.getElementById('quiereReunion') as HTMLInputElement).value);
        const agendadaReunion = parseInt((document.getElementById('agendadaReunion') as HTMLInputElement).value);

        const totalAcciones = presupuesto + autoridad + necesidad + tiempo + quiereReunion + agendadaReunion;
        const presupuestoPorcentaje = (presupuesto / totalAcciones) * 100;
        const autoridadPorcentaje = (autoridad / totalAcciones) * 100;
        const necesidadPorcentaje = (necesidad / totalAcciones) * 100;
        const tiempoPorcentaje = (tiempo / totalAcciones) * 100;
        const quiereReunionPorcentaje = (quiereReunion / totalAcciones) * 100;
        const agendadaReunionPorcentaje = (agendadaReunion / totalAcciones) * 100;

        let conclusion = 'Conclusión: ';
        if (totalAcciones === 100) {
            conclusion += 'Todas las acciones están completas.';
        } else {
            conclusion += 'No se han completado todas las acciones.';
        }

        const summary = `
Resumen:
- Presupuesto: ${presupuestoPorcentaje.toFixed(2)}% (${presupuestoPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})
- Autoridad: ${autoridadPorcentaje.toFixed(2)}% (${autoridadPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})
- Necesidad: ${necesidadPorcentaje.toFixed(2)}% (${necesidadPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})
- Tiempo: ${tiempoPorcentaje.toFixed(2)}% (${tiempoPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})
- Quiere reunión: ${quiereReunionPorcentaje.toFixed(2)}% (${quiereReunionPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})
- Agendada reunión: ${agendadaReunionPorcentaje.toFixed(2)}% (${agendadaReunionPorcentaje === 100 ? '100 (100 mucho interes y 0 poco interes)' : '0 (100 mucho interes y 0 poco interes)'})

${conclusion}
`;

        alert(summary);
    }


  constructor(public utils: UtilityProvider, public dm: DataManagement) { }

  ngOnInit(): void {
    setTimeout(() => {
      let tag = document.getElementById('saludo') as HTMLTextAreaElement;
      tag.value = '';
      tag = document.getElementById('contexto') as HTMLTextAreaElement;
      tag.value = '';
      tag = document.getElementById('indicadores') as HTMLTextAreaElement;
      tag.value = '';
    }, 500)
  }

}
